export const SET_CUSTOMER_SEARCH_PARAMS = 'constants/search/SET_CUSTOMER_SEARCH_PARAMS';
export const SET_VEHICLE_SEARCH_PARAMS = 'constants/search/SET_VEHICLE_SEARCH_PARAMS';

export const RESET_CUSTOMER_SEARCH_PARAMS = 'constants/search/RESET_CUSTOMER_SEARCH_PARAMS';
export const RESET_VEHICLE_SEARCH_PARAMS = 'constants/search/RESET_VEHICLE_SEARCH_PARAMS';
